import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {FirstLoginService} from "../../core/auth/services/first.login.service";
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {FirstLoginDialogComponent} from "./first-login-dialog/first-login-dialog.component";
import {Subject} from 'rxjs';
import {UserModel} from "../../core/user/user.model";
import {takeUntil} from 'rxjs/operators';
import {UserService} from "../../core/user/services/user.service";
import {AccountService} from "../../core/account/services/account.rest.service";
import {ReturnConditionsService} from "../return-conditions/services/return-conditions.service";

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$ = new Subject<void>();
  public user: UserModel | null = null;
  public loading = true;
  public canShowMasterDataTile = false;
  protected hasConditions = inject(ReturnConditionsService).hasConditions;


  constructor(private firstLogin: FirstLoginService,
              public userService: UserService,
              public accountService: AccountService,
              private dialog: MatDialog) {
  }

  ngOnInit() {
    if (this.firstLogin.showDialog) {
      this.showFirstLoginDialog();
    }

    // this.userService.loadUser();
    this.userService.getUserResponseObservable().pipe(takeUntil(this.ngUnsubscribe$)).subscribe(userResponse => {
      if (userResponse !== undefined) {
        this.loading = false;
        this.user = userResponse.user;
      }
    });

    this.userService.selectedIdf$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(idf => {
        this.updateMasterDataTileVisibility(idf || '');
      });
  }

  private updateMasterDataTileVisibility(idf: string): void {
    if (!idf) {
      this.canShowMasterDataTile = false;
      return;
    }

    const hasMasterDataAuthority = this.user?.authoritiesEnum?.includes('MASTER_DATA');
    const isOwner = this.userService.isOwner();

    if (hasMasterDataAuthority || isOwner) {
      this.canShowMasterDataTile = true;
      return;
    }

    this.accountService.loadAllAccountLicenseData(idf)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: response => {
          const licenseData = response?.return_object;
          this.canShowMasterDataTile = (licenseData?.documents?.length ?? 0) > 0;
        },
        error: () => {
          this.canShowMasterDataTile = false;
        }
      });
  }

  canAccessTile(authorities: any[]) {
    if (this.user) {
      if (this.userService.isAdmin()) {
        return true;
      }

      if (this.userService.isOwner()) {
        if(authorities.includes('PREISLISTE')){
          if(!(this.user.authoritiesEnum.filter(value => authorities.includes(value)).length > 0)){
            return false;
          }
        }
        return true;
      }

      if (this.user.authoritiesEnum.filter(value => authorities.includes(value)).length > 0) {
        return true;
      }
    }
    return false;
  }

  canAccessFeature(features: any[]){
    if(this.user){
      if(this.userService.isAdmin()) {
        return true;
      }


      if(this.user.canary && this.user.featuresEnum.filter(value => features.includes(value)).length > 0){
        return true;
      }
    }

    return false;
  }

  showFirstLoginDialog() {
    const firstLoginDialogConfig = new MatDialogConfig();
    firstLoginDialogConfig.width = '35rem';
    const dialogRef = this.dialog.open(FirstLoginDialogComponent, firstLoginDialogConfig);
  }


  isAdmin() {
    return this.userService.isAdmin();
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  protected goToSurvey() {
    window.open('https://phoenixgroup.survalyzer.eu/WHS_DE_Hageda', '_blank');
  }
}
